import React from "react";
import { useSelector } from "react-redux";
import Navigation from "../../components/navigation/Navigation";

const Home = () => {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  return (
    <div>
      {isLoggedIn ? (
        <div>
          <Navigation />
        </div>
      ) : (
        <div>404</div>
      )}
    </div>
  );
};

export default Home;
